import Hero from "./Hero";
import React from "react";
import { useTranslation } from "react-i18next";

const ContactFooter = () => {
  const { t } = useTranslation();

  const heroData = {
    image: "contact-footer.png",
    title: t("other.footer_contact_title"),
    subtitle: t("other.footer_contact_subtitle"),
    input: true,
  };
  return (
    <div className="footer-contact-section-holder">
      <Hero data={heroData} />
    </div>
  );
};

export default ContactFooter;
